import { useStore } from 'hooks/useStore';
import { useEffect, useRef, useState } from 'react';
import { tmsScreenServices } from 'services/tmsScreenServices';
import { useSearchParamsState } from 'hooks/useSearchParamState';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { tmsEditScreenDataInterface } from 'Interfaces/FDPInterfaces/tmsInterfaces';
import { convertIsoToDateString, getCurrentMonthDate } from 'utils/dateUtilities';
import { deepCopy } from 'utils/deepCopy';

type valueTypeInterface = 'saved' | 'old' | 'fromFacts';

export const useTargetMarketShate = () => {
  const [directCOT, setDirectCOT] = useState<{
    label: string;
    value: string;
  }>({ label: 'CMOP', value: 'CMOP' });
  const [indirectCOT, setIndirectCOT] = useState<{
    label: string;
    value: string;
  }>({ label: 'CMOP', value: 'CMOP' });
  const [isDirect, setIsdirect] = useState<boolean>(true);
  const [isDirectFinish, setIsDirectFinish] = useState<boolean>(true);
  const [confirmVisibility, setConfirmVisibility] = useState<boolean>(false);
  const [summaryVisibility, setSummaryVisibility] = useState<boolean>(false);
  const [finishConfirmVisibility, setFinishConfirmVisibility] = useState<boolean>(false);
  const [finishPopup, setFinishPopup] = useState<boolean>(false);
  const [sellingCategoryCotsHavingOldValues, setSellingCategoryCotsHavingOldValues] = useState<
    Set<string>
  >(new Set());
  const [savingAll, setSavingAll] = useState<boolean>(false);
  const [savingSingle, setSavingSingle] = useState<boolean>(false);
  const [savingCategory, setSavingCategory] = useState<boolean>(false);
  const [singleConfirmVisibility, setSingleConfirmVisibility] = useState<boolean>(false);
  const [isNoteEdited, setIsNoteEdited] = useState<Map<number, boolean>>(new Map());
  const [isNoteDeleted, setIsNoteDeleted] = useState<Map<number, boolean>>(new Map());

  const directInputFocus = useRef<HTMLInputElement[]>([]);
  const indirectInputFocus = useRef<HTMLInputElement[]>([]);
  const [directFocused, setDirectFocused] = useState<number | null>(null);
  const [indirectFocused, setIndirectFocused] = useState<number | null>(null);

  // let focussedInputBox: number | null = null;

  const [lastMSInput, setLastMSInput] = useState([
    { cot: 'CMOP', val: '' },
    { cot: 'VA Facility', val: '' },
    { cot: 'TMOP', val: '' },
    { cot: 'MTF', val: '' },
  ]);

  const {
    UserStore: { userModulesRoles },
    NavbarStore: { isNavigationRestricted, setisNavigationRestricted },
    MSPlanStore: {
      conceptDetails,
      isSalesDetailsLoading,
      TMSsalesSummaryData: MSplanConceptSalesDetails,
      istmsPlanDataDirectLoading,
      // salesplanstatus,
      msplandirectmode,
      msplanindirectmode,
      tmsEditData,
      oldtmsEditData,
      oldTmsData: _oldTmsData,
      isTMSNotesDataLoading,
      isConceptLoading,
      isConceptDetailsLoading,
      isTMSPlanViewDataLoading,
      contractDetails,
      istmsUpdateLoading,
      tmsSaveError,
      toggleMSplandirectmode,
      toggleMSplanindirectmode,
      saveTMSData,
      getTMSplanData,
      savePlanNote,
      fetchSalesPlanEditData,
      updateOldMSValues,
      fetchMSGFCNotes,
      isMSplanNoteSaving,
      tmsNotesData,
      setNoteData,
      removeNoteData,
      handleSetOldTmsEditData,
    },
  } = useStore();

  const [gfcParam, _setGfcParam] = useSearchParamsState('gfc', '');
  const navigate = useNavigate();
  const [confirmPopup, setConfirmPopup] = useState<boolean>(false);
  const [singleconfirmPopup, setSingleconfirmPopup] = useState<boolean>(false);
  const [copyRowinfo, setCopyRowinfo] = useState<Set<string>>(new Set());

  const [cotValueTypeUsing, setCotValueTypeUsing] = useState<Map<string, valueTypeInterface>>(
    new Map()
  );

  useEffect(() => {
    if (conceptDetails?.gfc && gfcParam && !istmsPlanDataDirectLoading) {
      getTMSplanData(parseInt(gfcParam));
      fetchMSGFCNotes(conceptDetails.gfc);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conceptDetails]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setisNavigationRestricted(true);

    return () => {
      setisNavigationRestricted(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavigateToViewScreen = () => {
    if (
      isNavigationRestricted &&
      tmsEditData.length > 0 &&
      JSON.stringify(tmsEditData) !== JSON.stringify(oldtmsEditData)
    ) {
      if (
        window.confirm(
          `Are you sure want to navigate?,
Changes done will not be saved!` // intensional removal of indentation for getting proper formatted message in the alert
        )
      ) {
        navigate(`/fdp/target_market?gfc=${conceptDetails?.gfc}`);
      }
    } else {
      navigate(`/fdp/target_market?gfc=${conceptDetails?.gfc}`);
    }
  };

  const getFutureMonths = () => {
    const arr: { label: string; dateString: string }[] = [];
    const dt = new Date();
    const startMonth = dt.getMonth();
    const startYear = dt.getFullYear();
    const monthShortHand = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    for (let i = 0; i < 15; i++) {
      const month = (startMonth + i + 1) % 12;
      const year = startYear + Math.floor((startMonth + i + 1) / 12);
      arr.push({
        label: `${monthShortHand[month]}-${year}`,
        dateString: `${year}-${month >= 9 ? month + 1 : `0${month + 1}`}-01`,
      });
    }

    return arr;
  };
  const tmsPlanningMonth: { label: string; dateString: string }[] = getFutureMonths();

  function isNumeric(value: string) {
    return /^[0-9][0-9]?$|^100$/.test(value);
  }

  const getValues = (cot: string, planningMonth: string, category: string, need: string) => {
    const tmsData = tmsEditData.filter(
      item =>
        item.COT.toLowerCase() === cot.toLowerCase() &&
        item.PlanningMonth === planningMonth &&
        item.SellingCategory.toLowerCase() === category.toLowerCase()
    );

    // if tms data is there, but empty check if and return
    if (tmsData.length == 0 || tmsData[0].MarketShare === null) {
      return '-';
    }

    if (need === 'stratCode') {
      if (tmsData.length === 0) {
        return '-';
      } else {
        return tmsData[0].TMSStrategyCode;
      }
    } else if (need === 'tmsval') {
      if (tmsData.length === 0) {
        return '-';
      } else {
        return String(Math.ceil(Number(tmsData[0].TargetMarketShare) * 100)) + '%';
      }
    } else if (need === 'msplan') {
      if (tmsData.length === 0) {
        return '-';
      } else {
        if (category === 'direct') {
          if (
            cotValueTypeUsing.get(directCOT.label.toLowerCase() + category.toLowerCase()) ===
            'fromFacts'
          ) {
            return tmsData[0].MarketShare;
          } else if (
            cotValueTypeUsing.get(directCOT.label.toLowerCase() + category.toLowerCase()) === 'old'
          ) {
            return tmsData[0].Old_MarketShare;
          } else {
            return tmsData[0].Saved_MarketShare;
          }
        } else if (category === 'indirect') {
          if (
            cotValueTypeUsing.get(directCOT.label.toLowerCase() + category.toLowerCase()) ===
            'fromFacts'
          ) {
            return tmsData[0].MarketShare;
          } else if (
            cotValueTypeUsing.get(directCOT.label.toLowerCase() + category.toLowerCase()) === 'old'
          ) {
            return tmsData[0].Old_MarketShare;
          } else {
            return tmsData[0].Saved_MarketShare;
          }
        }
      }
    }
  };

  const updateMSPlanValue = (
    msplan: string,
    cot: string,
    planningDate: string,
    category: string
  ) => {
    if ((isNumeric(msplan) && parseFloat(msplan) >= 0) || msplan === '') {
      const idx = tmsEditData.findIndex(
        item =>
          item.COT.toLocaleLowerCase() === cot.toLocaleLowerCase() &&
          item.PlanningMonth === planningDate &&
          item.SellingCategory.toLocaleLowerCase() === category
      );

      // check the data is empty coming from backend for particular month
      if (idx == -1 || tmsEditData[idx].MarketShare === null) {
        return;
      }

      if (category === 'direct') {
        if (cotValueTypeUsing.get(directCOT.value.toLowerCase() + 'direct') === 'fromFacts') {
          tmsEditData[idx].MarketShare = msplan;
        } else if (cotValueTypeUsing.get(directCOT.value.toLowerCase() + 'direct') === 'saved') {
          tmsEditData[idx].Saved_MarketShare = msplan;
        } else {
          tmsEditData[idx].Old_MarketShare = msplan;
        }
      } else if (category === 'indirect') {
        if (cotValueTypeUsing.get(directCOT.value.toLowerCase() + 'indirect') === 'fromFacts') {
          tmsEditData[idx].MarketShare = msplan;
        } else if (cotValueTypeUsing.get(directCOT.value.toLowerCase() + 'indirect') === 'saved') {
          tmsEditData[idx].Saved_MarketShare = msplan;
        } else {
          tmsEditData[idx].Old_MarketShare = msplan;
        }
      }

      if (
        !(
          isOldValuesCheckBoxChecked(true, directCOT.value) ||
          isOldValuesCheckBoxChecked(false, directCOT.value)
        )
      ) {
        console.log('updating the last input value');
        setLastMSInput(prev =>
          prev.map(item => (item.cot === cot ? { ...item, val: msplan } : item))
        );
      }
    }
  };

  const getSalesSummaryVal = (cot: string, type: string, cat: string) => {
    if (isSalesDetailsLoading) return undefined;

    // Handle cases where data might be undefined or empty
    if (!MSplanConceptSalesDetails || MSplanConceptSalesDetails.length === 0) {
      return 'NA';
    }

    const val = MSplanConceptSalesDetails.find(
      item => item.COT.toLowerCase() === cot.toLowerCase()
    );
    if (!val) return 'NA';

    switch (type) {
      case 'YTD':
        if (cat === 'direct') {
          if (val.YearToDateDirectShare !== null) {
            if (val.YearToDateDirectShare === 0) return val.YearToDateDirectShare;
            return val.YearToDateDirectShare + '%';
          } else {
            return 'NA';
          }
        } else if (cat === 'indirect') {
          if (val.YearToDateIndirectShare !== null) {
            if (val.YearToDateIndirectShare === 0) return val.YearToDateIndirectShare;
            return val.YearToDateIndirectShare + '%';
          } else {
            return 'NA';
          }
        }
        break;

      case '3MA':
        if (cat === 'direct') {
          if (val.LastThreeMonthDirectShare !== null) {
            if (val.LastThreeMonthDirectShare === 0) return val.LastThreeMonthDirectShare;
            return val.LastThreeMonthDirectShare + '%';
          } else {
            return 'NA';
          }
        } else if (cat === 'indirect') {
          if (val.LastThreeMonthIndirectShare !== null) {
            if (val.LastThreeMonthIndirectShare === 0) return val.LastThreeMonthIndirectShare;
            return val.LastThreeMonthIndirectShare + '%';
          } else {
            return 'NA';
          }
        }
        break;

      case 'PM':
        if (cat === 'direct') {
          if (val.LastMonthDirectShare !== null) {
            if (val.LastMonthDirectShare === 0) return val.LastMonthDirectShare;
            return val.LastMonthDirectShare + '%';
          } else {
            return 'NA';
          }
        } else if (cat === 'indirect') {
          if (val.LastMonthIndirectShare !== null) {
            if (val.LastMonthIndirectShare === 0) return val.LastMonthIndirectShare;
            return val.LastMonthIndirectShare + '%';
          } else {
            return 'NA';
          }
        }
        break;

      default:
        return 'NA';
    }
  };

  const getPlanningPeriod = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    return `${year}-${month}-01`;
  };

  const handleFinishforCategory = async (next: () => void) => {
    const category = isDirectFinish ? 'direct' : 'indirect';

    const payload: {
      MarketShareID: number;
      TMSPlanningMonth: string;
      Adjustment: number;
      MarketSharePlan: number;
      Note: string;
      PlanningPeriod: string;
    }[] = [];

    const planning_period = getPlanningPeriod();
    const editedIndexes: number[] = [];

    const cotPlans = tmsEditData.filter((item, index) => {
      if (item.SellingCategory.toLocaleLowerCase() === category) {
        editedIndexes.push(index);
        return true;
      } else {
        return false;
      }
    });

    const initialOldTmsEditData = deepCopy(oldtmsEditData);

    let currentIndexForPayloadCreation = -1;
    for (const plan of cotPlans) {
      currentIndexForPayloadCreation++;
      if (plan.MarketShare === null) continue;

      let mktshare: string = '';
      if (
        cotValueTypeUsing.get(
          directCOT.value.toLowerCase() + plan.SellingCategory.toLowerCase()
        ) === 'fromFacts'
      ) {
        mktshare = plan.MarketShare;
        oldtmsEditData[currentIndexForPayloadCreation].MarketShare = plan.MarketShare;
      } else if (
        cotValueTypeUsing.get(
          directCOT.value.toLowerCase() + plan.SellingCategory.toLowerCase()
        ) === 'old'
      ) {
        mktshare = plan.Old_MarketShare;
        oldtmsEditData[currentIndexForPayloadCreation].Old_MarketShare = plan.Old_MarketShare;
      } else {
        oldtmsEditData[currentIndexForPayloadCreation].Saved_MarketShare = plan.Saved_MarketShare;
        mktshare = plan.Saved_MarketShare;
      }

      const adjustment = Number(
        (Number(mktshare) / 100 - Number(plan.TargetMarketShare)).toFixed(2)
      );

      const obj = {
        MarketShareID: plan.MarketShareID,
        TMSPlanningMonth: plan.PlanningMonth,
        Adjustment: adjustment,
        MarketSharePlan: Number((Number(mktshare) / 100).toFixed(2)),
        Note: 'note',
        PlanningPeriod: planning_period,
      };
      payload.push(obj);
    }
    try {
      setSavingCategory(true);
      const data = await tmsScreenServices.updateTMSData(payload);
      // updateOldMSValues();
      if (data && conceptDetails) {
        fetchSalesPlanEditData(getCurrentMonthDate(), conceptDetails?.gfc);
      }
    } catch (error) {
      console.log('handleSaveAllCOTMSplan=> ', error);
      handleSetOldTmsEditData(initialOldTmsEditData);
    } finally {
      setFinishConfirmVisibility(false);
      setSavingCategory(false);
      if (!istmsUpdateLoading && !tmsSaveError) {
        next();
      }
      // setFinish(true);
      setCopyRowinfo(new Set());
    }
  };

  const handleSaveAllCOTMSplan = async (next: () => void) => {
    const payload: {
      MarketShareID: number;
      TMSPlanningMonth: string;
      Adjustment: number;
      MarketSharePlan: number;
      Note: string;
      PlanningPeriod: string;
    }[] = [];

    const planning_period = getPlanningPeriod();

    for (const plan of tmsEditData) {
      if (plan.MarketShare === null) continue;
      let mktshare: string = '';
      if (
        cotValueTypeUsing.get(
          directCOT.value.toLowerCase() + plan.SellingCategory.toLowerCase()
        ) === 'fromFacts'
      ) {
        mktshare = plan.MarketShare;
      } else if (
        cotValueTypeUsing.get(
          directCOT.value.toLowerCase() + plan.SellingCategory.toLowerCase()
        ) === 'old'
      ) {
        mktshare = plan.Old_MarketShare;
      } else {
        mktshare = plan.Saved_MarketShare;
      }

      const marketShare = Number(mktshare) / 100;
      const targetMarketShare = Number(plan.TargetMarketShare);
      const adjustment = Number((marketShare - targetMarketShare).toFixed(2));

      const obj = {
        MarketShareID: plan.MarketShareID,
        TMSPlanningMonth: plan.PlanningMonth,
        Adjustment: adjustment,
        MarketSharePlan: Number((Number(mktshare) / 100).toFixed(2)),
        Note: 'note',
        PlanningPeriod: planning_period,
      };
      payload.push(obj);
    }

    try {
      setSavingAll(true);
      await saveTMSData(payload);
      updateOldMSValues();
    } catch (error) {
      console.log('handleSaveAllCOTMSplan=> ', error);
      toast.error('Unable to save the MS plan.');
    } finally {
      setSavingAll(false);
      if (!istmsUpdateLoading && !tmsSaveError) {
        next();
      }
      setCopyRowinfo(new Set());
    }
  };

  const handleSaveSingleCOTMSplan = async () => {
    const category = isDirect ? 'direct' : 'indirect';
    const selectedcot = isDirect ? directCOT.value : indirectCOT.value;

    const payload: {
      MarketShareID: number;
      TMSPlanningMonth: string;
      Adjustment: number;
      MarketSharePlan: number;
      Note: string;
      PlanningPeriod: string;
    }[] = [];

    const planning_period = getPlanningPeriod();
    const editedIndexes: number[] = [];
    const cotPlans = tmsEditData.filter((item, index) => {
      if (
        item.COT.toLowerCase() === selectedcot.toLowerCase() &&
        item.SellingCategory.toLocaleLowerCase() === category
      ) {
        editedIndexes.push(index);
        return true;
      } else {
        return false;
      }
    });

    const initialOldTmsEditData = deepCopy(oldtmsEditData);

    let currentIndexForPayloadCreation = -1;
    for (const plan of cotPlans) {
      currentIndexForPayloadCreation++;
      if (plan.MarketShare === null) continue;

      let mktshare: string = '';
      if (
        cotValueTypeUsing.get(
          directCOT.value.toLowerCase() + plan.SellingCategory.toLowerCase()
        ) === 'fromFacts'
      ) {
        mktshare = plan.MarketShare;
        oldtmsEditData[currentIndexForPayloadCreation].MarketShare = plan.MarketShare;
      } else if (
        cotValueTypeUsing.get(
          directCOT.value.toLowerCase() + plan.SellingCategory.toLowerCase()
        ) === 'old'
      ) {
        mktshare = plan.Old_MarketShare;
        oldtmsEditData[currentIndexForPayloadCreation].Old_MarketShare = plan.Old_MarketShare;
      } else {
        mktshare = plan.Saved_MarketShare;
        oldtmsEditData[currentIndexForPayloadCreation].Saved_MarketShare = plan.Saved_MarketShare;
      }

      const adjustment = Number(
        (Number(mktshare) / 100 - Number(plan.TargetMarketShare)).toFixed(2)
      );

      const obj = {
        MarketShareID: plan.MarketShareID,
        TMSPlanningMonth: plan.PlanningMonth,
        Adjustment: adjustment,
        MarketSharePlan: Number((Number(mktshare) / 100).toFixed(2)),
        Note: 'note',
        PlanningPeriod: planning_period,
      };
      payload.push(obj);
    }
    try {
      setSavingSingle(true);
      await tmsScreenServices.updateTMSData(payload);
      // updateOldMSValues();
    } catch (error) {
      console.log('handleSaveAllCOTMSplan=> ', error);
      handleSetOldTmsEditData(initialOldTmsEditData);
    } finally {
      setSingleConfirmVisibility(false);
      setSavingSingle(false);
      setCopyRowinfo(new Set());
    }
  };

  const isOldValueCheckBoxVisible = (cot: string, isDirect: boolean) => {
    // check whether we can even toggle it or not
    if (cotValueTypeUsing.get(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect')) === 'saved')
      return false;

    if (
      !sellingCategoryCotsHavingOldValues.has(
        cot.toLowerCase() + (isDirect ? 'direct' : 'indirect')
      )
    ) {
      return false;
    }

    return true;
  };

  const isOldValuesCheckBoxChecked = (isDirect: boolean, cot: string) => {
    return cotValueTypeUsing.get(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect')) === 'old'
      ? true
      : false;
  };

  const toggleOldValuesChekedSwitch = (cot: string, isDirect: boolean) => {
    const tempCotValueTypeUsing: Map<string, valueTypeInterface> = new Map(cotValueTypeUsing);
    if (
      tempCotValueTypeUsing.get(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect')) === 'old'
    ) {
      tempCotValueTypeUsing.set(
        cot.toLowerCase() + (isDirect ? 'direct' : 'indirect'),
        'fromFacts'
      );
    } else {
      tempCotValueTypeUsing.set(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect'), 'old');
    }
    setCotValueTypeUsing(tempCotValueTypeUsing);
  };

  const handleNoteAdd = (value: string) => {
    try {
      if (value.trim() === '') {
        toast.warning('Cannot save an empty note!!');
      } else if (conceptDetails && conceptDetails.gfc && value.trim() !== '') {
        savePlanNote(Number(conceptDetails?.gfc), value.trim(), 'sales plan', 'msplan');
      }
    } catch (error) {
      console.log('handleSubmit=> Error while saving Note: ', error);
    }
  };

  const handleEditNote = async (id: number, note: string) => {
    try {
      setIsNoteEdited(prev => {
        const temp = new Map(prev);
        if (temp.has(id)) {
          temp.set(id, true);
        } else {
          temp.set(id, true);
        }
        return temp;
      });
      const data = await tmsScreenServices.updateNote(id, note);
      if (data.status) {
        tmsNotesData.map(item => {
          if (item.ID === id) {
            item.CreatedDate = convertIsoToDateString(data.lastUpdatedDate) || '';
          }
        });
        toast.success('Note Updated successfully.');
      }
    } catch (error) {
      console.log('handleEditNote=> ', error);
      toast.error('Something went wrong.');
    } finally {
      setIsNoteEdited(prev => {
        const temp = new Map(prev);
        if (temp.has(id)) {
          temp.set(id, false);
        } else {
          if (temp.get(id)) {
            temp.set(id, false);
          }
        }
        return temp;
      });
    }
  };

  const handleDeleteNote = async (id: number) => {
    toast.success('Note deleted successfully.');
    try {
      setIsNoteDeleted(prev => {
        const temp = prev;
        if (temp.has(id)) {
          temp.set(id, true);
        } else {
          temp.set(id, true);
        }
        return temp;
      });
      await tmsScreenServices.deleteNote(id);
      // if (data) {
      //   toast.success("Note deleted successfully.");
      // }
    } catch (_error) {
      console.log('handleEditNote=> ', _error);
      toast.error('Something went wrong.');
    } finally {
      setIsNoteDeleted(prev => {
        const temp = prev;
        if (temp.has(id)) {
          temp.set(id, false);
        } else {
          temp.set(id, false);
        }
        return temp;
      });
    }
  };

  const copyBtnStatus = () => {
    const lastval = lastMSInput.filter(item => item.cot === directCOT.label);
    const valCheck = tmsEditData.filter(
      item => item.COT === directCOT.label && item.MarketShare === lastval[0].val
    );

    return valCheck.length === 0 && lastval[0].val === '';
  };

  const handleCopyButtonClick = (isDirect: boolean, monthIndex: number) => {
    if (monthIndex <= tmsPlanningMonth.length - 1) {
      const cot = isDirect ? directCOT.value : indirectCOT.value;
      const sell_cat: string = isDirect ? 'direct' : 'indirect';
      const val = getValues(cot, tmsPlanningMonth[monthIndex].dateString, sell_cat, 'msplan');

      if (val === '-' || val === '') {
        toast.error(`Empty value cannot be copied`);
        return;
      }

      for (let i = monthIndex + 1; i < tmsPlanningMonth.length; i++) {
        if (val !== undefined) {
          updateMSPlanValue(val, cot, tmsPlanningMonth[i].dateString, sell_cat);
        }
      }
      const tempSet = new Set([
        cot.toLowerCase() + tmsPlanningMonth[monthIndex].dateString + sell_cat.toLowerCase(),
      ]);
      setCopyRowinfo(tempSet);
      toast.success(`Copied ${val} to all rows`);
    }
  };

  const handleResetButtonClick = (isDirect: boolean, monthIndex: number) => {
    if (monthIndex < tmsPlanningMonth.length) {
      const cotType = isDirect ? directCOT.value : indirectCOT.value;
      const selling_category = isDirect ? 'direct' : 'indirect';

      const getMSplanVal = (
        data: tmsEditScreenDataInterface,
        cot: string,
        month: string,
        category: string
      ) => {
        const dataItem = data.filter(
          item =>
            item.COT.toLowerCase() === cotType.toLowerCase() &&
            item.PlanningMonth === month &&
            item.SellingCategory.toLowerCase() === selling_category.toLowerCase()
        );
        if (cotValueTypeUsing.get(cot.toLowerCase() + category.toLowerCase()) === 'fromFacts') {
          return dataItem[0].MarketShare;
        } else if (cotValueTypeUsing.get(cot.toLowerCase() + category.toLowerCase()) === 'old') {
          return dataItem[0].Old_MarketShare;
        } else {
          return dataItem[0].Saved_MarketShare;
        }
      };

      for (let i = monthIndex; i < tmsPlanningMonth.length; i++) {
        const planningMonth = tmsPlanningMonth[i].dateString;

        const oldVal = getMSplanVal(oldtmsEditData, cotType, planningMonth, selling_category);

        updateMSPlanValue(oldVal, cotType, planningMonth, selling_category);
      }
      setCopyRowinfo(new Set());
      toast.success('Restored values to default values');
    }
  };

  useEffect(() => {
    const tempusingOldValuesCotsDirect: Set<string> = new Set();
    const tempCotValueTypeUsing: Map<string, valueTypeInterface> = new Map();

    tmsEditData.forEach(data => {
      if (data.isSavedMarketSharePresent) {
        tempCotValueTypeUsing.set(
          data.COT.toLowerCase() + data.SellingCategory.toLowerCase(),
          'saved'
        );
      } else if (data.isOldMarketSharePresent) {
        tempCotValueTypeUsing.set(
          data.COT.toLowerCase() + data.SellingCategory.toLowerCase(),
          'old'
        );
        tempusingOldValuesCotsDirect.add(
          data.COT.toLowerCase() + data.SellingCategory.toLowerCase()
        );
      } else {
        tempCotValueTypeUsing.set(
          data.COT.toLowerCase() + data.SellingCategory.toLowerCase(),
          'fromFacts'
        );
      }
    });

    setCotValueTypeUsing(tempCotValueTypeUsing);
    setSellingCategoryCotsHavingOldValues(tempusingOldValuesCotsDirect);
  }, [tmsEditData]);

  const handleDirectKeyPress = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (index < tmsPlanningMonth.length - 1) {
        directInputFocus.current[index + 1]?.focus();
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (index > 0) {
        directInputFocus.current[index - 1]?.focus();
      }
    }
  };

  const handleIndirectKeyPress = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (index < tmsPlanningMonth.length - 1) {
        indirectInputFocus.current[index + 1]?.focus();
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (index > 0) {
        indirectInputFocus.current[index - 1]?.focus();
      }
    }
  };

  const handleDirectFocus = (index: number) => {
    setDirectFocused(index);
  };

  const handleIndirectFocus = (index: number) => {
    setIndirectFocused(index);
  };

  const handleDirectBlur = () => {
    setDirectFocused(null);
  };

  const handleIndirectBlur = () => {
    setIndirectFocused(null);
  };

  const getIsDeramped = (cot: string, planningMonth: string, category: string): boolean => {
    const entry = tmsEditData.find(
      item =>
        item.COT.toLowerCase() === cot.toLowerCase() &&
        item.PlanningMonth === planningMonth &&
        item.SellingCategory.toLowerCase() === category.toLowerCase(),
    );
    return entry?.is_deramped === true;
  };

  return {
    userModulesRoles,
    conceptDetails,
    contractDetails,
    tmsPlanningMonth,
    confirmVisibility,
    summaryVisibility,
    directCOT,
    isSalesDetailsLoading,
    istmsPlanDataDirectLoading,
    singleConfirmVisibility,
    savingAll,
    savingSingle,
    savingCategory,
    msplandirectmode,
    msplanindirectmode,
    isConceptLoading,
    isConceptDetailsLoading,
    isTMSNotesDataLoading,
    tmsEditData,
    isTMSPlanViewDataLoading,
    istmsUpdateLoading,
    confirmPopup,
    singleconfirmPopup,
    lastMSInput,
    indirectCOT,
    isDirect,
    isDirectFinish,
    finishPopup,
    finishConfirmVisibility,
    copyRowinfo,
    setFinishConfirmVisibility,
    setFinishPopup,
    setIsDirectFinish,
    setIsdirect,
    setIndirectCOT,
    handleNavigateToViewScreen,
    setSingleconfirmPopup,
    setConfirmPopup,
    setConfirmVisibility,
    setSummaryVisibility,
    setDirectCOT,
    setSingleConfirmVisibility,
    getSalesSummaryVal,
    getValues,
    getIsDeramped,
    updateMSPlanValue,
    handleSaveAllCOTMSplan,
    handleFinishforCategory,
    handleSaveSingleCOTMSplan,
    setSavingAll,
    setSavingSingle,
    toggleMSplandirectmode,
    toggleMSplanindirectmode,
    isOldValueCheckBoxVisible,
    isOldValuesCheckBoxChecked,
    toggleOldValuesChekedSwitch,
    isMSplanNoteSaving,
    tmsNotesData,
    handleNoteAdd,
    handleCopyButtonClick,
    copyBtnStatus,
    handleResetButtonClick,
    handleDeleteNote,
    handleEditNote,
    setNoteData,
    removeNoteData,
    isNoteEdited,
    isNoteDeleted,
    directInputFocus,
    indirectInputFocus,
    directFocused,
    indirectFocused,
    handleDirectKeyPress,
    handleIndirectKeyPress,
    handleDirectFocus,
    handleIndirectFocus,
    handleDirectBlur,
    handleIndirectBlur,
  };
};
